export default __webpack_public_path__ + "static/media/Hållbart professionell_ljudläggare_mixare_2021.4640cd65.png";